import React from 'react';
import { Link } from 'react-router-dom';

function ErrorPage({ code, title, message, pathHint }) {
  return (
    <div className="page-shell error-page">
      <p className="error-page-code">{code}</p>
      <h2>{title}</h2>
      <p className="page-lead">{message}</p>
      {pathHint ? <p className="error-page-path">请求路径：{pathHint}</p> : null}
      <div className="page-actions">
        <Link to="/" className="link-card" title="首页">
          返回首页
        </Link>
        <button type="button" className="btn btn-secondary" onClick={() => window.history.back()} title="前一页">
          返回上一页
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;
